import calculateCurrentStep from './calculateCurrentStep'
import {useSteps} from './steps'

export const useStepperData = (stepperData) => {
  const currentStep = calculateCurrentStep(stepperData)
  const onboardingSteps = useSteps({
    ...stepperData,
    currentStep,
  })
  const completed = onboardingSteps.every((step) => step.status === 'completed')

  return {
    onboardingSteps,
    currentStep,
    completed,
  }
}
